const PERMISSION_KEY= "personalize:user_workspace";
const PAGE_URL = {
    USER_WORKSPACE_PAGE: "/admin/personalize/user-workspace"
}

export {PERMISSION_KEY, PAGE_URL}

